import { render, staticRenderFns } from "./PaymentsSuccessInfo.vue?vue&type=template&id=225acc0f"
import script from "./PaymentsSuccessInfo.vue?vue&type=script&lang=js"
export * from "./PaymentsSuccessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports